import { useEffect } from "react";
import { useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { ItemTypes } from "../../../abstract/controller/enum/dnd/ItemTypes";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as pathUtils from "../../../abstract/controller/utils/pathUtils";
import {
  getStatusPositioned,
  setDrag,
  setIdle,
  setPosition,
} from "../../../abstract/redux/slice/statusSlice";
import {
  getIdFunction,
  getNodeStructure,
  getRoot,
  handleFunctionMove,
} from "../../../abstract/redux/slice/structureSlice";
import Icon317ArrowRight2 from "../../../themes/icons/Icon317ArrowRight2";
import { DragOverlay } from "../../ui/overlay/DragOverlay";
import styles from "./FunctionPanel.module.scss";
import { showFunctionDrop } from "./logic/showFunctionDrop";

function FunctionPanel({ id }) {
  const _dispatch = useDispatch();
  const _isStatusPositioned = useSelector(getStatusPositioned);
  const _idFunction = useSelector(getIdFunction);

  const _node = useSelector(getNodeStructure(id ?? pathUtils.getIdMarkerRoot()));
  const _nodeParent = useSelector(getRoot);

  //---------------------------------------------------------------------

  const [{ _idNodeDrag, _isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.FUNCTION,
      collect: (monitor) => ({
        _idNodeDrag: nodeUtils.getID(monitor.getItem()?.element),
        _isOver: monitor.isOver(),
        _canDrop: monitor.canDrop(),
      }),
      canDrop(item) {
        return showFunctionDrop(item.element, _node, _nodeParent);
      },
      drop(item) {
        _dispatch(setIdle());
        _dispatch(handleFunctionMove(nodeUtils.getID(item.element), id));
      },
    }),
    [id, _node, _nodeParent]
  );

  useEffect(() => {
    if (_isOver) {
      _dispatch(setPosition({ hidden: true }));
    } else {
      _dispatch(setDrag({ fromPosition: true }));
    }
  }, [_isOver, _dispatch]);

  //---------------------------------------------------------------------

  const _isNodeOver = _isStatusPositioned && _isOver;

  const getClass = () => {
    return `${styles["panel-choice"]} ${_isNodeOver ? styles["panel-choice--extended"] : ""}`;
  };

  return (
    <div ref={drop} className={getClass()}>
      {_isNodeOver ? (
        <div className={styles["panel-choice-drag"]}>
          <div className={styles["panel-choice-drag-selector"]}>
            {_idNodeDrag !== _idFunction ? "" : <Icon317ArrowRight2 />}
          </div>
          <div className={styles["panel-choice-drag-overlay"]}>
            <DragOverlay type={ItemTypes.FUNCTION} isVisible />
          </div>
        </div>
      ) : (
        <div>&nbsp;</div>
      )}
    </div>
  );
}

export default FunctionPanel;
